//companies can have more specific rules for which variant field values to render

export const exchangeItemSelectConfig = {
  Fulton: {
    variantRules: [
      {
        when: {
          Gender: "Women",
        },
        then: {
          Size: {
            disallow: ["13", "14"],
          },
        },
      },
      {
        when: {
          Gender: "Men",
        },
        then: {
          Size: {
            disallow: ["5", "6", "7"],
          },
        },
      },
    ],
  },
};
